import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchAllCategories, fetchExchangeRates } from "./http/ProductAPI";
import { checkAuth } from "./http/UserAPI";
import { createExchangeRates, fetchCategories, hideLoader } from "./redux/actions";
import Router from "./Router";
import Spinner from "./UI/spinner/Spinner";

const App = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.app.isLoading);

  const fetchData = async () => {
    try {
      // Запускаем независимые запросы параллельно, а не один за другим —
      // так стартовый экран не ждёт сумму всех ответов.
      const authPromise = localStorage.getItem("accessToken")
        ? checkAuth()
        : Promise.resolve();

      const [exchange, categories] = await Promise.all([
        fetchExchangeRates(),
        fetchAllCategories(),
        authPromise,
      ]);

      dispatch(createExchangeRates(exchange));
      dispatch(fetchCategories(categories || []));
    } catch (error) {
      // Даже при ошибке/таймауте не оставляем сайт в вечной загрузке.
      console.error(error);
    } finally {
      dispatch(hideLoader());
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    loading ? 
    <div className="flex items-center justify-center h-screen">
      <Spinner />
    </div>
    :
    <Router />
  );
};

export default App;
